import * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const UpdateMetaobjectByIdDocument = gql`
    mutation UpdateMetaobjectById($id: ID!, $metaobject: MetaobjectUpdateInput!) {
  metaobjectUpdate(id: $id, metaobject: $metaobject) {
    metaobject {
      id
      type
      fields {
        key
        value
      }
    }
    userErrors {
      field
      message
      code
    }
  }
}
    `;
export type UpdateMetaobjectByIdMutationFn = Apollo.MutationFunction<Types.UpdateMetaobjectByIdMutation, Types.UpdateMetaobjectByIdMutationVariables>;

/**
 * __useUpdateMetaobjectByIdMutation__
 *
 * To run a mutation, you first call `useUpdateMetaobjectByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMetaobjectByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMetaobjectByIdMutation, { data, loading, error }] = useUpdateMetaobjectByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      metaobject: // value for 'metaobject'
 *   },
 * });
 */
export function useUpdateMetaobjectByIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMetaobjectByIdMutation, Types.UpdateMetaobjectByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMetaobjectByIdMutation, Types.UpdateMetaobjectByIdMutationVariables>(UpdateMetaobjectByIdDocument, options);
      }
export type UpdateMetaobjectByIdMutationHookResult = ReturnType<typeof useUpdateMetaobjectByIdMutation>;
export type UpdateMetaobjectByIdMutationResult = Apollo.MutationResult<Types.UpdateMetaobjectByIdMutation>;
export type UpdateMetaobjectByIdMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMetaobjectByIdMutation, Types.UpdateMetaobjectByIdMutationVariables>;
export const FetchCheckoutAndAccountsBrandingDocument = gql`
    query FetchCheckoutAndAccountsBranding($id: ID!) {
  checkoutAndAccountsConfiguration(id: $id) {
    id
    branding {
      components {
        shared {
          colors {
            warning
            success
            info
            critical
            decorative
            accent
            button
          }
        }
        header {
          colors {
            base {
              background
              text
              border
              accent
            }
          }
        }
        main {
          colors {
            base {
              background
              text
              border
            }
            primaryButton {
              background
              text
              border
            }
            secondaryButton {
              background
              text
              border
            }
          }
        }
        textField {
          border
        }
        select {
          border
        }
        primaryButton {
          cornerRadius
          blockPadding
          inlinePadding
          border
        }
      }
      designTokens {
        cornerRadius {
          base
          small
          large
        }
        colors {
          palette {
            color1
            color10
            color11
            color9
            color8
            color6
            color7
            color5
            color4
            color3
            color20
            color2
            color17
            color18
            color19
            color16
            color15
            color14
            color13
            color12
          }
        }
      }
      surfaces {
        checkout {
          components {
            main {
              colors {
                base {
                  background
                }
              }
              section {
                background
                border
                borderStyle
                borderWidth
                cornerRadius
                padding
                shadow
              }
            }
            orderSummary {
              colors {
                base {
                  background
                  text
                  accent
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchCheckoutAndAccountsBrandingQuery__
 *
 * To run a query within a React component, call `useFetchCheckoutAndAccountsBrandingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCheckoutAndAccountsBrandingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCheckoutAndAccountsBrandingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchCheckoutAndAccountsBrandingQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchCheckoutAndAccountsBrandingQuery, Types.FetchCheckoutAndAccountsBrandingQueryVariables> & ({ variables: Types.FetchCheckoutAndAccountsBrandingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchCheckoutAndAccountsBrandingQuery, Types.FetchCheckoutAndAccountsBrandingQueryVariables>(FetchCheckoutAndAccountsBrandingDocument, options);
      }
export function useFetchCheckoutAndAccountsBrandingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchCheckoutAndAccountsBrandingQuery, Types.FetchCheckoutAndAccountsBrandingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchCheckoutAndAccountsBrandingQuery, Types.FetchCheckoutAndAccountsBrandingQueryVariables>(FetchCheckoutAndAccountsBrandingDocument, options);
        }
// @ts-ignore
export function useFetchCheckoutAndAccountsBrandingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchCheckoutAndAccountsBrandingQuery, Types.FetchCheckoutAndAccountsBrandingQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchCheckoutAndAccountsBrandingQuery, Types.FetchCheckoutAndAccountsBrandingQueryVariables>;
export function useFetchCheckoutAndAccountsBrandingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchCheckoutAndAccountsBrandingQuery, Types.FetchCheckoutAndAccountsBrandingQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchCheckoutAndAccountsBrandingQuery | undefined, Types.FetchCheckoutAndAccountsBrandingQueryVariables>;
export function useFetchCheckoutAndAccountsBrandingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchCheckoutAndAccountsBrandingQuery, Types.FetchCheckoutAndAccountsBrandingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchCheckoutAndAccountsBrandingQuery, Types.FetchCheckoutAndAccountsBrandingQueryVariables>(FetchCheckoutAndAccountsBrandingDocument, options);
        }
export type FetchCheckoutAndAccountsBrandingQueryHookResult = ReturnType<typeof useFetchCheckoutAndAccountsBrandingQuery>;
export type FetchCheckoutAndAccountsBrandingLazyQueryHookResult = ReturnType<typeof useFetchCheckoutAndAccountsBrandingLazyQuery>;
export type FetchCheckoutAndAccountsBrandingSuspenseQueryHookResult = ReturnType<typeof useFetchCheckoutAndAccountsBrandingSuspenseQuery>;
export type FetchCheckoutAndAccountsBrandingQueryResult = Apollo.QueryResult<Types.FetchCheckoutAndAccountsBrandingQuery, Types.FetchCheckoutAndAccountsBrandingQueryVariables>;
export const FetchCheckoutBrandingDocument = gql`
    query FetchCheckoutBranding($id: ID!) {
  checkoutBranding(checkoutProfileId: $id) {
    designSystem {
      colors {
        global {
          warning
          success
          info
          decorative
          brand
          accent
          critical
        }
        schemes {
          scheme1 {
            base {
              background
              accent
              decorative
              text
              border
            }
            primaryButton {
              background
            }
          }
          scheme2 {
            base {
              decorative
              background
              accent
              border
            }
          }
        }
      }
    }
    customizations {
      main {
        colorScheme
        section {
          colorScheme
          background
          border
        }
      }
    }
  }
}
    `;

/**
 * __useFetchCheckoutBrandingQuery__
 *
 * To run a query within a React component, call `useFetchCheckoutBrandingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCheckoutBrandingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCheckoutBrandingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchCheckoutBrandingQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchCheckoutBrandingQuery, Types.FetchCheckoutBrandingQueryVariables> & ({ variables: Types.FetchCheckoutBrandingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchCheckoutBrandingQuery, Types.FetchCheckoutBrandingQueryVariables>(FetchCheckoutBrandingDocument, options);
      }
export function useFetchCheckoutBrandingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchCheckoutBrandingQuery, Types.FetchCheckoutBrandingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchCheckoutBrandingQuery, Types.FetchCheckoutBrandingQueryVariables>(FetchCheckoutBrandingDocument, options);
        }
// @ts-ignore
export function useFetchCheckoutBrandingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchCheckoutBrandingQuery, Types.FetchCheckoutBrandingQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchCheckoutBrandingQuery, Types.FetchCheckoutBrandingQueryVariables>;
export function useFetchCheckoutBrandingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchCheckoutBrandingQuery, Types.FetchCheckoutBrandingQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchCheckoutBrandingQuery | undefined, Types.FetchCheckoutBrandingQueryVariables>;
export function useFetchCheckoutBrandingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchCheckoutBrandingQuery, Types.FetchCheckoutBrandingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchCheckoutBrandingQuery, Types.FetchCheckoutBrandingQueryVariables>(FetchCheckoutBrandingDocument, options);
        }
export type FetchCheckoutBrandingQueryHookResult = ReturnType<typeof useFetchCheckoutBrandingQuery>;
export type FetchCheckoutBrandingLazyQueryHookResult = ReturnType<typeof useFetchCheckoutBrandingLazyQuery>;
export type FetchCheckoutBrandingSuspenseQueryHookResult = ReturnType<typeof useFetchCheckoutBrandingSuspenseQuery>;
export type FetchCheckoutBrandingQueryResult = Apollo.QueryResult<Types.FetchCheckoutBrandingQuery, Types.FetchCheckoutBrandingQueryVariables>;
export const FetchCheckoutProfilesDocument = gql`
    query FetchCheckoutProfiles($after: String) {
  checkoutProfiles(first: 10, after: $after) {
    edges {
      node {
        id
        name
        isPublished
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useFetchCheckoutProfilesQuery__
 *
 * To run a query within a React component, call `useFetchCheckoutProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCheckoutProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCheckoutProfilesQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFetchCheckoutProfilesQuery(baseOptions?: Apollo.QueryHookOptions<Types.FetchCheckoutProfilesQuery, Types.FetchCheckoutProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchCheckoutProfilesQuery, Types.FetchCheckoutProfilesQueryVariables>(FetchCheckoutProfilesDocument, options);
      }
export function useFetchCheckoutProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchCheckoutProfilesQuery, Types.FetchCheckoutProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchCheckoutProfilesQuery, Types.FetchCheckoutProfilesQueryVariables>(FetchCheckoutProfilesDocument, options);
        }
// @ts-ignore
export function useFetchCheckoutProfilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchCheckoutProfilesQuery, Types.FetchCheckoutProfilesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchCheckoutProfilesQuery, Types.FetchCheckoutProfilesQueryVariables>;
export function useFetchCheckoutProfilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchCheckoutProfilesQuery, Types.FetchCheckoutProfilesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchCheckoutProfilesQuery | undefined, Types.FetchCheckoutProfilesQueryVariables>;
export function useFetchCheckoutProfilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchCheckoutProfilesQuery, Types.FetchCheckoutProfilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchCheckoutProfilesQuery, Types.FetchCheckoutProfilesQueryVariables>(FetchCheckoutProfilesDocument, options);
        }
export type FetchCheckoutProfilesQueryHookResult = ReturnType<typeof useFetchCheckoutProfilesQuery>;
export type FetchCheckoutProfilesLazyQueryHookResult = ReturnType<typeof useFetchCheckoutProfilesLazyQuery>;
export type FetchCheckoutProfilesSuspenseQueryHookResult = ReturnType<typeof useFetchCheckoutProfilesSuspenseQuery>;
export type FetchCheckoutProfilesQueryResult = Apollo.QueryResult<Types.FetchCheckoutProfilesQuery, Types.FetchCheckoutProfilesQueryVariables>;
export const FetchGwpGiftVariantsDocument = gql`
    query FetchGwpGiftVariants($ids: [ID!]!) {
  nodes(ids: $ids) {
    ... on Product {
      id
      title
      featuredImage {
        url
      }
      options {
        name
        values
      }
      variants(first: 250) {
        edges {
          node {
            id
            availableForSale
            price
            compareAtPrice
            image {
              url(transform: {maxWidth: 240, maxHeight: 240})
            }
            selectedOptions {
              name
              value
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchGwpGiftVariantsQuery__
 *
 * To run a query within a React component, call `useFetchGwpGiftVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchGwpGiftVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchGwpGiftVariantsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useFetchGwpGiftVariantsQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchGwpGiftVariantsQuery, Types.FetchGwpGiftVariantsQueryVariables> & ({ variables: Types.FetchGwpGiftVariantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchGwpGiftVariantsQuery, Types.FetchGwpGiftVariantsQueryVariables>(FetchGwpGiftVariantsDocument, options);
      }
export function useFetchGwpGiftVariantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchGwpGiftVariantsQuery, Types.FetchGwpGiftVariantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchGwpGiftVariantsQuery, Types.FetchGwpGiftVariantsQueryVariables>(FetchGwpGiftVariantsDocument, options);
        }
// @ts-ignore
export function useFetchGwpGiftVariantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchGwpGiftVariantsQuery, Types.FetchGwpGiftVariantsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchGwpGiftVariantsQuery, Types.FetchGwpGiftVariantsQueryVariables>;
export function useFetchGwpGiftVariantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchGwpGiftVariantsQuery, Types.FetchGwpGiftVariantsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchGwpGiftVariantsQuery | undefined, Types.FetchGwpGiftVariantsQueryVariables>;
export function useFetchGwpGiftVariantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchGwpGiftVariantsQuery, Types.FetchGwpGiftVariantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchGwpGiftVariantsQuery, Types.FetchGwpGiftVariantsQueryVariables>(FetchGwpGiftVariantsDocument, options);
        }
export type FetchGwpGiftVariantsQueryHookResult = ReturnType<typeof useFetchGwpGiftVariantsQuery>;
export type FetchGwpGiftVariantsLazyQueryHookResult = ReturnType<typeof useFetchGwpGiftVariantsLazyQuery>;
export type FetchGwpGiftVariantsSuspenseQueryHookResult = ReturnType<typeof useFetchGwpGiftVariantsSuspenseQuery>;
export type FetchGwpGiftVariantsQueryResult = Apollo.QueryResult<Types.FetchGwpGiftVariantsQuery, Types.FetchGwpGiftVariantsQueryVariables>;
export const FetchImagesDocument = gql`
    query FetchImages($first: Int!, $cursor: String, $query: String) {
  files(
    first: $first
    after: $cursor
    query: $query
    sortKey: CREATED_AT
    reverse: true
  ) {
    edges {
      cursor
      node {
        ... on Node {
          id
        }
        ... on MediaImage {
          id
          alt
          image {
            id
            url
            width
            height
            altText
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useFetchImagesQuery__
 *
 * To run a query within a React component, call `useFetchImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchImagesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFetchImagesQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchImagesQuery, Types.FetchImagesQueryVariables> & ({ variables: Types.FetchImagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchImagesQuery, Types.FetchImagesQueryVariables>(FetchImagesDocument, options);
      }
export function useFetchImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchImagesQuery, Types.FetchImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchImagesQuery, Types.FetchImagesQueryVariables>(FetchImagesDocument, options);
        }
// @ts-ignore
export function useFetchImagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchImagesQuery, Types.FetchImagesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchImagesQuery, Types.FetchImagesQueryVariables>;
export function useFetchImagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchImagesQuery, Types.FetchImagesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchImagesQuery | undefined, Types.FetchImagesQueryVariables>;
export function useFetchImagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchImagesQuery, Types.FetchImagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchImagesQuery, Types.FetchImagesQueryVariables>(FetchImagesDocument, options);
        }
export type FetchImagesQueryHookResult = ReturnType<typeof useFetchImagesQuery>;
export type FetchImagesLazyQueryHookResult = ReturnType<typeof useFetchImagesLazyQuery>;
export type FetchImagesSuspenseQueryHookResult = ReturnType<typeof useFetchImagesSuspenseQuery>;
export type FetchImagesQueryResult = Apollo.QueryResult<Types.FetchImagesQuery, Types.FetchImagesQueryVariables>;
export const FetchMetaobjectsDocument = gql`
    query FetchMetaobjects($type: String!, $cursor: String) {
  metaobjects(type: $type, first: 250, after: $cursor) {
    edges {
      node {
        id
        displayName
        type
        fields {
          value
          type
          key
        }
      }
    }
  }
}
    `;

/**
 * __useFetchMetaobjectsQuery__
 *
 * To run a query within a React component, call `useFetchMetaobjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMetaobjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMetaobjectsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useFetchMetaobjectsQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchMetaobjectsQuery, Types.FetchMetaobjectsQueryVariables> & ({ variables: Types.FetchMetaobjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchMetaobjectsQuery, Types.FetchMetaobjectsQueryVariables>(FetchMetaobjectsDocument, options);
      }
export function useFetchMetaobjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchMetaobjectsQuery, Types.FetchMetaobjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchMetaobjectsQuery, Types.FetchMetaobjectsQueryVariables>(FetchMetaobjectsDocument, options);
        }
// @ts-ignore
export function useFetchMetaobjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchMetaobjectsQuery, Types.FetchMetaobjectsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchMetaobjectsQuery, Types.FetchMetaobjectsQueryVariables>;
export function useFetchMetaobjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchMetaobjectsQuery, Types.FetchMetaobjectsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchMetaobjectsQuery | undefined, Types.FetchMetaobjectsQueryVariables>;
export function useFetchMetaobjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchMetaobjectsQuery, Types.FetchMetaobjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchMetaobjectsQuery, Types.FetchMetaobjectsQueryVariables>(FetchMetaobjectsDocument, options);
        }
export type FetchMetaobjectsQueryHookResult = ReturnType<typeof useFetchMetaobjectsQuery>;
export type FetchMetaobjectsLazyQueryHookResult = ReturnType<typeof useFetchMetaobjectsLazyQuery>;
export type FetchMetaobjectsSuspenseQueryHookResult = ReturnType<typeof useFetchMetaobjectsSuspenseQuery>;
export type FetchMetaobjectsQueryResult = Apollo.QueryResult<Types.FetchMetaobjectsQuery, Types.FetchMetaobjectsQueryVariables>;
export const FetchNavigationDocument = gql`
    query FetchNavigation($first: Int!, $query: String) {
  pages(first: $first, query: $query, sortKey: TITLE) {
    edges {
      node {
        title
        handle
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  collections(first: $first, query: $query, sortKey: TITLE) {
    edges {
      node {
        title
        handle
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  products(first: $first, query: $query, sortKey: TITLE) {
    edges {
      node {
        title
        handle
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  articles(first: $first, query: $query, sortKey: TITLE) {
    edges {
      node {
        title
        handle
        blog {
          handle
        }
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useFetchNavigationQuery__
 *
 * To run a query within a React component, call `useFetchNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchNavigationQuery({
 *   variables: {
 *      first: // value for 'first'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFetchNavigationQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchNavigationQuery, Types.FetchNavigationQueryVariables> & ({ variables: Types.FetchNavigationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchNavigationQuery, Types.FetchNavigationQueryVariables>(FetchNavigationDocument, options);
      }
export function useFetchNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchNavigationQuery, Types.FetchNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchNavigationQuery, Types.FetchNavigationQueryVariables>(FetchNavigationDocument, options);
        }
// @ts-ignore
export function useFetchNavigationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchNavigationQuery, Types.FetchNavigationQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchNavigationQuery, Types.FetchNavigationQueryVariables>;
export function useFetchNavigationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchNavigationQuery, Types.FetchNavigationQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchNavigationQuery | undefined, Types.FetchNavigationQueryVariables>;
export function useFetchNavigationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchNavigationQuery, Types.FetchNavigationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchNavigationQuery, Types.FetchNavigationQueryVariables>(FetchNavigationDocument, options);
        }
export type FetchNavigationQueryHookResult = ReturnType<typeof useFetchNavigationQuery>;
export type FetchNavigationLazyQueryHookResult = ReturnType<typeof useFetchNavigationLazyQuery>;
export type FetchNavigationSuspenseQueryHookResult = ReturnType<typeof useFetchNavigationSuspenseQuery>;
export type FetchNavigationQueryResult = Apollo.QueryResult<Types.FetchNavigationQuery, Types.FetchNavigationQueryVariables>;
export const FetchNavigationArticlesDocument = gql`
    query FetchNavigationArticles($first: Int!, $after: String, $query: String) {
  articles(first: $first, after: $after, query: $query, sortKey: TITLE) {
    edges {
      node {
        title
        handle
        blog {
          handle
        }
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useFetchNavigationArticlesQuery__
 *
 * To run a query within a React component, call `useFetchNavigationArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchNavigationArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchNavigationArticlesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFetchNavigationArticlesQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchNavigationArticlesQuery, Types.FetchNavigationArticlesQueryVariables> & ({ variables: Types.FetchNavigationArticlesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchNavigationArticlesQuery, Types.FetchNavigationArticlesQueryVariables>(FetchNavigationArticlesDocument, options);
      }
export function useFetchNavigationArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchNavigationArticlesQuery, Types.FetchNavigationArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchNavigationArticlesQuery, Types.FetchNavigationArticlesQueryVariables>(FetchNavigationArticlesDocument, options);
        }
// @ts-ignore
export function useFetchNavigationArticlesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchNavigationArticlesQuery, Types.FetchNavigationArticlesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchNavigationArticlesQuery, Types.FetchNavigationArticlesQueryVariables>;
export function useFetchNavigationArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchNavigationArticlesQuery, Types.FetchNavigationArticlesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchNavigationArticlesQuery | undefined, Types.FetchNavigationArticlesQueryVariables>;
export function useFetchNavigationArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchNavigationArticlesQuery, Types.FetchNavigationArticlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchNavigationArticlesQuery, Types.FetchNavigationArticlesQueryVariables>(FetchNavigationArticlesDocument, options);
        }
export type FetchNavigationArticlesQueryHookResult = ReturnType<typeof useFetchNavigationArticlesQuery>;
export type FetchNavigationArticlesLazyQueryHookResult = ReturnType<typeof useFetchNavigationArticlesLazyQuery>;
export type FetchNavigationArticlesSuspenseQueryHookResult = ReturnType<typeof useFetchNavigationArticlesSuspenseQuery>;
export type FetchNavigationArticlesQueryResult = Apollo.QueryResult<Types.FetchNavigationArticlesQuery, Types.FetchNavigationArticlesQueryVariables>;
export const FetchNavigationCollectionsDocument = gql`
    query FetchNavigationCollections($first: Int!, $after: String, $query: String) {
  collections(first: $first, after: $after, query: $query, sortKey: TITLE) {
    edges {
      node {
        title
        handle
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useFetchNavigationCollectionsQuery__
 *
 * To run a query within a React component, call `useFetchNavigationCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchNavigationCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchNavigationCollectionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFetchNavigationCollectionsQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchNavigationCollectionsQuery, Types.FetchNavigationCollectionsQueryVariables> & ({ variables: Types.FetchNavigationCollectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchNavigationCollectionsQuery, Types.FetchNavigationCollectionsQueryVariables>(FetchNavigationCollectionsDocument, options);
      }
export function useFetchNavigationCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchNavigationCollectionsQuery, Types.FetchNavigationCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchNavigationCollectionsQuery, Types.FetchNavigationCollectionsQueryVariables>(FetchNavigationCollectionsDocument, options);
        }
// @ts-ignore
export function useFetchNavigationCollectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchNavigationCollectionsQuery, Types.FetchNavigationCollectionsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchNavigationCollectionsQuery, Types.FetchNavigationCollectionsQueryVariables>;
export function useFetchNavigationCollectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchNavigationCollectionsQuery, Types.FetchNavigationCollectionsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchNavigationCollectionsQuery | undefined, Types.FetchNavigationCollectionsQueryVariables>;
export function useFetchNavigationCollectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchNavigationCollectionsQuery, Types.FetchNavigationCollectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchNavigationCollectionsQuery, Types.FetchNavigationCollectionsQueryVariables>(FetchNavigationCollectionsDocument, options);
        }
export type FetchNavigationCollectionsQueryHookResult = ReturnType<typeof useFetchNavigationCollectionsQuery>;
export type FetchNavigationCollectionsLazyQueryHookResult = ReturnType<typeof useFetchNavigationCollectionsLazyQuery>;
export type FetchNavigationCollectionsSuspenseQueryHookResult = ReturnType<typeof useFetchNavigationCollectionsSuspenseQuery>;
export type FetchNavigationCollectionsQueryResult = Apollo.QueryResult<Types.FetchNavigationCollectionsQuery, Types.FetchNavigationCollectionsQueryVariables>;
export const FetchNavigationPagesDocument = gql`
    query FetchNavigationPages($first: Int!, $after: String, $query: String) {
  pages(first: $first, after: $after, query: $query, sortKey: TITLE) {
    edges {
      node {
        title
        handle
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useFetchNavigationPagesQuery__
 *
 * To run a query within a React component, call `useFetchNavigationPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchNavigationPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchNavigationPagesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFetchNavigationPagesQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchNavigationPagesQuery, Types.FetchNavigationPagesQueryVariables> & ({ variables: Types.FetchNavigationPagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchNavigationPagesQuery, Types.FetchNavigationPagesQueryVariables>(FetchNavigationPagesDocument, options);
      }
export function useFetchNavigationPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchNavigationPagesQuery, Types.FetchNavigationPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchNavigationPagesQuery, Types.FetchNavigationPagesQueryVariables>(FetchNavigationPagesDocument, options);
        }
// @ts-ignore
export function useFetchNavigationPagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchNavigationPagesQuery, Types.FetchNavigationPagesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchNavigationPagesQuery, Types.FetchNavigationPagesQueryVariables>;
export function useFetchNavigationPagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchNavigationPagesQuery, Types.FetchNavigationPagesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchNavigationPagesQuery | undefined, Types.FetchNavigationPagesQueryVariables>;
export function useFetchNavigationPagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchNavigationPagesQuery, Types.FetchNavigationPagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchNavigationPagesQuery, Types.FetchNavigationPagesQueryVariables>(FetchNavigationPagesDocument, options);
        }
export type FetchNavigationPagesQueryHookResult = ReturnType<typeof useFetchNavigationPagesQuery>;
export type FetchNavigationPagesLazyQueryHookResult = ReturnType<typeof useFetchNavigationPagesLazyQuery>;
export type FetchNavigationPagesSuspenseQueryHookResult = ReturnType<typeof useFetchNavigationPagesSuspenseQuery>;
export type FetchNavigationPagesQueryResult = Apollo.QueryResult<Types.FetchNavigationPagesQuery, Types.FetchNavigationPagesQueryVariables>;
export const FetchNavigationProductsDocument = gql`
    query FetchNavigationProducts($first: Int!, $after: String, $query: String) {
  products(first: $first, after: $after, query: $query, sortKey: TITLE) {
    edges {
      node {
        title
        handle
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useFetchNavigationProductsQuery__
 *
 * To run a query within a React component, call `useFetchNavigationProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchNavigationProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchNavigationProductsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFetchNavigationProductsQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchNavigationProductsQuery, Types.FetchNavigationProductsQueryVariables> & ({ variables: Types.FetchNavigationProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchNavigationProductsQuery, Types.FetchNavigationProductsQueryVariables>(FetchNavigationProductsDocument, options);
      }
export function useFetchNavigationProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchNavigationProductsQuery, Types.FetchNavigationProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchNavigationProductsQuery, Types.FetchNavigationProductsQueryVariables>(FetchNavigationProductsDocument, options);
        }
// @ts-ignore
export function useFetchNavigationProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchNavigationProductsQuery, Types.FetchNavigationProductsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchNavigationProductsQuery, Types.FetchNavigationProductsQueryVariables>;
export function useFetchNavigationProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchNavigationProductsQuery, Types.FetchNavigationProductsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchNavigationProductsQuery | undefined, Types.FetchNavigationProductsQueryVariables>;
export function useFetchNavigationProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchNavigationProductsQuery, Types.FetchNavigationProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchNavigationProductsQuery, Types.FetchNavigationProductsQueryVariables>(FetchNavigationProductsDocument, options);
        }
export type FetchNavigationProductsQueryHookResult = ReturnType<typeof useFetchNavigationProductsQuery>;
export type FetchNavigationProductsLazyQueryHookResult = ReturnType<typeof useFetchNavigationProductsLazyQuery>;
export type FetchNavigationProductsSuspenseQueryHookResult = ReturnType<typeof useFetchNavigationProductsSuspenseQuery>;
export type FetchNavigationProductsQueryResult = Apollo.QueryResult<Types.FetchNavigationProductsQuery, Types.FetchNavigationProductsQueryVariables>;
export const FetchPagesAllDocument = gql`
    query FetchPagesAll($endCursor: String) {
  pages(first: 250, query: "published_status:published", after: $endCursor) {
    edges {
      node {
        id
        title
        handle
        templateSuffix
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useFetchPagesAllQuery__
 *
 * To run a query within a React component, call `useFetchPagesAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPagesAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPagesAllQuery({
 *   variables: {
 *      endCursor: // value for 'endCursor'
 *   },
 * });
 */
export function useFetchPagesAllQuery(baseOptions?: Apollo.QueryHookOptions<Types.FetchPagesAllQuery, Types.FetchPagesAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchPagesAllQuery, Types.FetchPagesAllQueryVariables>(FetchPagesAllDocument, options);
      }
export function useFetchPagesAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchPagesAllQuery, Types.FetchPagesAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchPagesAllQuery, Types.FetchPagesAllQueryVariables>(FetchPagesAllDocument, options);
        }
// @ts-ignore
export function useFetchPagesAllSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchPagesAllQuery, Types.FetchPagesAllQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchPagesAllQuery, Types.FetchPagesAllQueryVariables>;
export function useFetchPagesAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchPagesAllQuery, Types.FetchPagesAllQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchPagesAllQuery | undefined, Types.FetchPagesAllQueryVariables>;
export function useFetchPagesAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchPagesAllQuery, Types.FetchPagesAllQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchPagesAllQuery, Types.FetchPagesAllQueryVariables>(FetchPagesAllDocument, options);
        }
export type FetchPagesAllQueryHookResult = ReturnType<typeof useFetchPagesAllQuery>;
export type FetchPagesAllLazyQueryHookResult = ReturnType<typeof useFetchPagesAllLazyQuery>;
export type FetchPagesAllSuspenseQueryHookResult = ReturnType<typeof useFetchPagesAllSuspenseQuery>;
export type FetchPagesAllQueryResult = Apollo.QueryResult<Types.FetchPagesAllQuery, Types.FetchPagesAllQueryVariables>;
export const FetchProductDocument = gql`
    query FetchProduct($id: ID!) {
  product(id: $id) {
    id
    title
    handle
    featuredImage {
      url(transform: {maxWidth: 50, maxHeight: 50})
    }
    requiresSellingPlan
    variants(first: 250) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          price
          compareAtPrice
        }
      }
    }
  }
}
    `;

/**
 * __useFetchProductQuery__
 *
 * To run a query within a React component, call `useFetchProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchProductQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchProductQuery, Types.FetchProductQueryVariables> & ({ variables: Types.FetchProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchProductQuery, Types.FetchProductQueryVariables>(FetchProductDocument, options);
      }
export function useFetchProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchProductQuery, Types.FetchProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchProductQuery, Types.FetchProductQueryVariables>(FetchProductDocument, options);
        }
// @ts-ignore
export function useFetchProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchProductQuery, Types.FetchProductQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductQuery, Types.FetchProductQueryVariables>;
export function useFetchProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductQuery, Types.FetchProductQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductQuery | undefined, Types.FetchProductQueryVariables>;
export function useFetchProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductQuery, Types.FetchProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchProductQuery, Types.FetchProductQueryVariables>(FetchProductDocument, options);
        }
export type FetchProductQueryHookResult = ReturnType<typeof useFetchProductQuery>;
export type FetchProductLazyQueryHookResult = ReturnType<typeof useFetchProductLazyQuery>;
export type FetchProductSuspenseQueryHookResult = ReturnType<typeof useFetchProductSuspenseQuery>;
export type FetchProductQueryResult = Apollo.QueryResult<Types.FetchProductQuery, Types.FetchProductQueryVariables>;
export const FetchProductAndVariantImagesDocument = gql`
    query FetchProductAndVariantImages($ids: [ID!]!) {
  nodes(ids: $ids) {
    ... on Product {
      id
      title
      featuredImage {
        url(transform: {maxWidth: 96, maxHeight: 96})
      }
    }
    ... on ProductVariant {
      id
      title
      price
      image {
        url(transform: {maxWidth: 96, maxHeight: 96})
      }
      product {
        id
        title
        featuredImage {
          url(transform: {maxWidth: 96, maxHeight: 96})
        }
      }
    }
  }
}
    `;

/**
 * __useFetchProductAndVariantImagesQuery__
 *
 * To run a query within a React component, call `useFetchProductAndVariantImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductAndVariantImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductAndVariantImagesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useFetchProductAndVariantImagesQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchProductAndVariantImagesQuery, Types.FetchProductAndVariantImagesQueryVariables> & ({ variables: Types.FetchProductAndVariantImagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchProductAndVariantImagesQuery, Types.FetchProductAndVariantImagesQueryVariables>(FetchProductAndVariantImagesDocument, options);
      }
export function useFetchProductAndVariantImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchProductAndVariantImagesQuery, Types.FetchProductAndVariantImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchProductAndVariantImagesQuery, Types.FetchProductAndVariantImagesQueryVariables>(FetchProductAndVariantImagesDocument, options);
        }
// @ts-ignore
export function useFetchProductAndVariantImagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchProductAndVariantImagesQuery, Types.FetchProductAndVariantImagesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductAndVariantImagesQuery, Types.FetchProductAndVariantImagesQueryVariables>;
export function useFetchProductAndVariantImagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductAndVariantImagesQuery, Types.FetchProductAndVariantImagesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductAndVariantImagesQuery | undefined, Types.FetchProductAndVariantImagesQueryVariables>;
export function useFetchProductAndVariantImagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductAndVariantImagesQuery, Types.FetchProductAndVariantImagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchProductAndVariantImagesQuery, Types.FetchProductAndVariantImagesQueryVariables>(FetchProductAndVariantImagesDocument, options);
        }
export type FetchProductAndVariantImagesQueryHookResult = ReturnType<typeof useFetchProductAndVariantImagesQuery>;
export type FetchProductAndVariantImagesLazyQueryHookResult = ReturnType<typeof useFetchProductAndVariantImagesLazyQuery>;
export type FetchProductAndVariantImagesSuspenseQueryHookResult = ReturnType<typeof useFetchProductAndVariantImagesSuspenseQuery>;
export type FetchProductAndVariantImagesQueryResult = Apollo.QueryResult<Types.FetchProductAndVariantImagesQuery, Types.FetchProductAndVariantImagesQueryVariables>;
export const FetchProductCountDocument = gql`
    query FetchProductCount($query: String) {
  productsCount(query: $query) {
    count
  }
}
    `;

/**
 * __useFetchProductCountQuery__
 *
 * To run a query within a React component, call `useFetchProductCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFetchProductCountQuery(baseOptions?: Apollo.QueryHookOptions<Types.FetchProductCountQuery, Types.FetchProductCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchProductCountQuery, Types.FetchProductCountQueryVariables>(FetchProductCountDocument, options);
      }
export function useFetchProductCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchProductCountQuery, Types.FetchProductCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchProductCountQuery, Types.FetchProductCountQueryVariables>(FetchProductCountDocument, options);
        }
// @ts-ignore
export function useFetchProductCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchProductCountQuery, Types.FetchProductCountQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductCountQuery, Types.FetchProductCountQueryVariables>;
export function useFetchProductCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductCountQuery, Types.FetchProductCountQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductCountQuery | undefined, Types.FetchProductCountQueryVariables>;
export function useFetchProductCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductCountQuery, Types.FetchProductCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchProductCountQuery, Types.FetchProductCountQueryVariables>(FetchProductCountDocument, options);
        }
export type FetchProductCountQueryHookResult = ReturnType<typeof useFetchProductCountQuery>;
export type FetchProductCountLazyQueryHookResult = ReturnType<typeof useFetchProductCountLazyQuery>;
export type FetchProductCountSuspenseQueryHookResult = ReturnType<typeof useFetchProductCountSuspenseQuery>;
export type FetchProductCountQueryResult = Apollo.QueryResult<Types.FetchProductCountQuery, Types.FetchProductCountQueryVariables>;
export const FetchProductImagesDocument = gql`
    query FetchProductImages($ids: [ID!]!) {
  nodes(ids: $ids) {
    ... on Product {
      id
      featuredImage {
        url(transform: {maxWidth: 50, maxHeight: 50})
      }
    }
  }
}
    `;

/**
 * __useFetchProductImagesQuery__
 *
 * To run a query within a React component, call `useFetchProductImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductImagesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useFetchProductImagesQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchProductImagesQuery, Types.FetchProductImagesQueryVariables> & ({ variables: Types.FetchProductImagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchProductImagesQuery, Types.FetchProductImagesQueryVariables>(FetchProductImagesDocument, options);
      }
export function useFetchProductImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchProductImagesQuery, Types.FetchProductImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchProductImagesQuery, Types.FetchProductImagesQueryVariables>(FetchProductImagesDocument, options);
        }
// @ts-ignore
export function useFetchProductImagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchProductImagesQuery, Types.FetchProductImagesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductImagesQuery, Types.FetchProductImagesQueryVariables>;
export function useFetchProductImagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductImagesQuery, Types.FetchProductImagesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductImagesQuery | undefined, Types.FetchProductImagesQueryVariables>;
export function useFetchProductImagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductImagesQuery, Types.FetchProductImagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchProductImagesQuery, Types.FetchProductImagesQueryVariables>(FetchProductImagesDocument, options);
        }
export type FetchProductImagesQueryHookResult = ReturnType<typeof useFetchProductImagesQuery>;
export type FetchProductImagesLazyQueryHookResult = ReturnType<typeof useFetchProductImagesLazyQuery>;
export type FetchProductImagesSuspenseQueryHookResult = ReturnType<typeof useFetchProductImagesSuspenseQuery>;
export type FetchProductImagesQueryResult = Apollo.QueryResult<Types.FetchProductImagesQuery, Types.FetchProductImagesQueryVariables>;
export const FetchProductOptionsDocument = gql`
    query FetchProductOptions($id: ID!, $after: String) {
  product(id: $id) {
    id
    title
    featuredImage {
      url
    }
    options {
      name
      values
    }
    variants(first: 250, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          availableForSale
          media(first: 1) {
            nodes {
              ... on MediaImage {
                image {
                  url(transform: {maxWidth: 50, maxHeight: 50})
                }
              }
            }
          }
          selectedOptions {
            name
            value
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchProductOptionsQuery__
 *
 * To run a query within a React component, call `useFetchProductOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductOptionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFetchProductOptionsQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchProductOptionsQuery, Types.FetchProductOptionsQueryVariables> & ({ variables: Types.FetchProductOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchProductOptionsQuery, Types.FetchProductOptionsQueryVariables>(FetchProductOptionsDocument, options);
      }
export function useFetchProductOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchProductOptionsQuery, Types.FetchProductOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchProductOptionsQuery, Types.FetchProductOptionsQueryVariables>(FetchProductOptionsDocument, options);
        }
// @ts-ignore
export function useFetchProductOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchProductOptionsQuery, Types.FetchProductOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductOptionsQuery, Types.FetchProductOptionsQueryVariables>;
export function useFetchProductOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductOptionsQuery, Types.FetchProductOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductOptionsQuery | undefined, Types.FetchProductOptionsQueryVariables>;
export function useFetchProductOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductOptionsQuery, Types.FetchProductOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchProductOptionsQuery, Types.FetchProductOptionsQueryVariables>(FetchProductOptionsDocument, options);
        }
export type FetchProductOptionsQueryHookResult = ReturnType<typeof useFetchProductOptionsQuery>;
export type FetchProductOptionsLazyQueryHookResult = ReturnType<typeof useFetchProductOptionsLazyQuery>;
export type FetchProductOptionsSuspenseQueryHookResult = ReturnType<typeof useFetchProductOptionsSuspenseQuery>;
export type FetchProductOptionsQueryResult = Apollo.QueryResult<Types.FetchProductOptionsQuery, Types.FetchProductOptionsQueryVariables>;
export const FetchProductPickerProductsDocument = gql`
    query FetchProductPickerProducts($first: Int, $after: String, $query: String) {
  products(first: $first, after: $after, query: $query) {
    edges {
      node {
        id
        title
        featuredMedia {
          ... on MediaImage {
            id
            image {
              url(transform: {maxWidth: 800, maxHeight: 800})
            }
          }
        }
        handle
        status
        hasVariantsThatRequiresComponents
        sellingPlanGroupsCount {
          count
        }
        requiresSellingPlan
        bundleComponents(first: $first) {
          nodes {
            quantity
            componentProduct {
              id
            }
          }
        }
        tags
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useFetchProductPickerProductsQuery__
 *
 * To run a query within a React component, call `useFetchProductPickerProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductPickerProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductPickerProductsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFetchProductPickerProductsQuery(baseOptions?: Apollo.QueryHookOptions<Types.FetchProductPickerProductsQuery, Types.FetchProductPickerProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchProductPickerProductsQuery, Types.FetchProductPickerProductsQueryVariables>(FetchProductPickerProductsDocument, options);
      }
export function useFetchProductPickerProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchProductPickerProductsQuery, Types.FetchProductPickerProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchProductPickerProductsQuery, Types.FetchProductPickerProductsQueryVariables>(FetchProductPickerProductsDocument, options);
        }
// @ts-ignore
export function useFetchProductPickerProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchProductPickerProductsQuery, Types.FetchProductPickerProductsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductPickerProductsQuery, Types.FetchProductPickerProductsQueryVariables>;
export function useFetchProductPickerProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductPickerProductsQuery, Types.FetchProductPickerProductsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductPickerProductsQuery | undefined, Types.FetchProductPickerProductsQueryVariables>;
export function useFetchProductPickerProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductPickerProductsQuery, Types.FetchProductPickerProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchProductPickerProductsQuery, Types.FetchProductPickerProductsQueryVariables>(FetchProductPickerProductsDocument, options);
        }
export type FetchProductPickerProductsQueryHookResult = ReturnType<typeof useFetchProductPickerProductsQuery>;
export type FetchProductPickerProductsLazyQueryHookResult = ReturnType<typeof useFetchProductPickerProductsLazyQuery>;
export type FetchProductPickerProductsSuspenseQueryHookResult = ReturnType<typeof useFetchProductPickerProductsSuspenseQuery>;
export type FetchProductPickerProductsQueryResult = Apollo.QueryResult<Types.FetchProductPickerProductsQuery, Types.FetchProductPickerProductsQueryVariables>;
export const FetchProductPickerProductsWithVariantsDocument = gql`
    query FetchProductPickerProductsWithVariants($first: Int, $after: String, $query: String, $variantsFirst: Int, $variantsAfter: String) {
  products(first: $first, after: $after, query: $query) {
    edges {
      node {
        id
        title
        featuredMedia {
          ... on MediaImage {
            id
            image {
              url(transform: {maxWidth: 800, maxHeight: 800})
            }
          }
        }
        handle
        status
        hasVariantsThatRequiresComponents
        sellingPlanGroupsCount {
          count
        }
        requiresSellingPlan
        bundleComponents(first: 5) {
          nodes {
            quantity
            componentProduct {
              id
            }
          }
        }
        tags
        options {
          name
          values
        }
        variants(first: $variantsFirst, after: $variantsAfter) {
          nodes {
            id
            title
            price
            compareAtPrice
            availableForSale
            media(first: 1) {
              nodes {
                ... on MediaImage {
                  image {
                    url(transform: {maxWidth: 50, maxHeight: 50})
                  }
                }
              }
            }
            selectedOptions {
              name
              value
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useFetchProductPickerProductsWithVariantsQuery__
 *
 * To run a query within a React component, call `useFetchProductPickerProductsWithVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductPickerProductsWithVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductPickerProductsWithVariantsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      query: // value for 'query'
 *      variantsFirst: // value for 'variantsFirst'
 *      variantsAfter: // value for 'variantsAfter'
 *   },
 * });
 */
export function useFetchProductPickerProductsWithVariantsQuery(baseOptions?: Apollo.QueryHookOptions<Types.FetchProductPickerProductsWithVariantsQuery, Types.FetchProductPickerProductsWithVariantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchProductPickerProductsWithVariantsQuery, Types.FetchProductPickerProductsWithVariantsQueryVariables>(FetchProductPickerProductsWithVariantsDocument, options);
      }
export function useFetchProductPickerProductsWithVariantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchProductPickerProductsWithVariantsQuery, Types.FetchProductPickerProductsWithVariantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchProductPickerProductsWithVariantsQuery, Types.FetchProductPickerProductsWithVariantsQueryVariables>(FetchProductPickerProductsWithVariantsDocument, options);
        }
// @ts-ignore
export function useFetchProductPickerProductsWithVariantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchProductPickerProductsWithVariantsQuery, Types.FetchProductPickerProductsWithVariantsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductPickerProductsWithVariantsQuery, Types.FetchProductPickerProductsWithVariantsQueryVariables>;
export function useFetchProductPickerProductsWithVariantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductPickerProductsWithVariantsQuery, Types.FetchProductPickerProductsWithVariantsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductPickerProductsWithVariantsQuery | undefined, Types.FetchProductPickerProductsWithVariantsQueryVariables>;
export function useFetchProductPickerProductsWithVariantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductPickerProductsWithVariantsQuery, Types.FetchProductPickerProductsWithVariantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchProductPickerProductsWithVariantsQuery, Types.FetchProductPickerProductsWithVariantsQueryVariables>(FetchProductPickerProductsWithVariantsDocument, options);
        }
export type FetchProductPickerProductsWithVariantsQueryHookResult = ReturnType<typeof useFetchProductPickerProductsWithVariantsQuery>;
export type FetchProductPickerProductsWithVariantsLazyQueryHookResult = ReturnType<typeof useFetchProductPickerProductsWithVariantsLazyQuery>;
export type FetchProductPickerProductsWithVariantsSuspenseQueryHookResult = ReturnType<typeof useFetchProductPickerProductsWithVariantsSuspenseQuery>;
export type FetchProductPickerProductsWithVariantsQueryResult = Apollo.QueryResult<Types.FetchProductPickerProductsWithVariantsQuery, Types.FetchProductPickerProductsWithVariantsQueryVariables>;
export const FetchProductPickerSelectedProductDocument = gql`
    query FetchProductPickerSelectedProduct($id: ID!) {
  product(id: $id) {
    id
    title
    featuredImage {
      url(transform: {maxWidth: 50, maxHeight: 50})
    }
    handle
    requiresSellingPlan
  }
}
    `;

/**
 * __useFetchProductPickerSelectedProductQuery__
 *
 * To run a query within a React component, call `useFetchProductPickerSelectedProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductPickerSelectedProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductPickerSelectedProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchProductPickerSelectedProductQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchProductPickerSelectedProductQuery, Types.FetchProductPickerSelectedProductQueryVariables> & ({ variables: Types.FetchProductPickerSelectedProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchProductPickerSelectedProductQuery, Types.FetchProductPickerSelectedProductQueryVariables>(FetchProductPickerSelectedProductDocument, options);
      }
export function useFetchProductPickerSelectedProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchProductPickerSelectedProductQuery, Types.FetchProductPickerSelectedProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchProductPickerSelectedProductQuery, Types.FetchProductPickerSelectedProductQueryVariables>(FetchProductPickerSelectedProductDocument, options);
        }
// @ts-ignore
export function useFetchProductPickerSelectedProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchProductPickerSelectedProductQuery, Types.FetchProductPickerSelectedProductQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductPickerSelectedProductQuery, Types.FetchProductPickerSelectedProductQueryVariables>;
export function useFetchProductPickerSelectedProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductPickerSelectedProductQuery, Types.FetchProductPickerSelectedProductQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductPickerSelectedProductQuery | undefined, Types.FetchProductPickerSelectedProductQueryVariables>;
export function useFetchProductPickerSelectedProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductPickerSelectedProductQuery, Types.FetchProductPickerSelectedProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchProductPickerSelectedProductQuery, Types.FetchProductPickerSelectedProductQueryVariables>(FetchProductPickerSelectedProductDocument, options);
        }
export type FetchProductPickerSelectedProductQueryHookResult = ReturnType<typeof useFetchProductPickerSelectedProductQuery>;
export type FetchProductPickerSelectedProductLazyQueryHookResult = ReturnType<typeof useFetchProductPickerSelectedProductLazyQuery>;
export type FetchProductPickerSelectedProductSuspenseQueryHookResult = ReturnType<typeof useFetchProductPickerSelectedProductSuspenseQuery>;
export type FetchProductPickerSelectedProductQueryResult = Apollo.QueryResult<Types.FetchProductPickerSelectedProductQuery, Types.FetchProductPickerSelectedProductQueryVariables>;
export const FetchProductPickerSelectedProductsDocument = gql`
    query FetchProductPickerSelectedProducts($ids: [ID!]!) {
  nodes(ids: $ids) {
    ... on Product {
      id
      title
      featuredImage {
        url(transform: {maxWidth: 50, maxHeight: 50})
      }
      handle
      requiresSellingPlan
    }
  }
}
    `;

/**
 * __useFetchProductPickerSelectedProductsQuery__
 *
 * To run a query within a React component, call `useFetchProductPickerSelectedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductPickerSelectedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductPickerSelectedProductsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useFetchProductPickerSelectedProductsQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchProductPickerSelectedProductsQuery, Types.FetchProductPickerSelectedProductsQueryVariables> & ({ variables: Types.FetchProductPickerSelectedProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchProductPickerSelectedProductsQuery, Types.FetchProductPickerSelectedProductsQueryVariables>(FetchProductPickerSelectedProductsDocument, options);
      }
export function useFetchProductPickerSelectedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchProductPickerSelectedProductsQuery, Types.FetchProductPickerSelectedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchProductPickerSelectedProductsQuery, Types.FetchProductPickerSelectedProductsQueryVariables>(FetchProductPickerSelectedProductsDocument, options);
        }
// @ts-ignore
export function useFetchProductPickerSelectedProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchProductPickerSelectedProductsQuery, Types.FetchProductPickerSelectedProductsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductPickerSelectedProductsQuery, Types.FetchProductPickerSelectedProductsQueryVariables>;
export function useFetchProductPickerSelectedProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductPickerSelectedProductsQuery, Types.FetchProductPickerSelectedProductsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductPickerSelectedProductsQuery | undefined, Types.FetchProductPickerSelectedProductsQueryVariables>;
export function useFetchProductPickerSelectedProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductPickerSelectedProductsQuery, Types.FetchProductPickerSelectedProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchProductPickerSelectedProductsQuery, Types.FetchProductPickerSelectedProductsQueryVariables>(FetchProductPickerSelectedProductsDocument, options);
        }
export type FetchProductPickerSelectedProductsQueryHookResult = ReturnType<typeof useFetchProductPickerSelectedProductsQuery>;
export type FetchProductPickerSelectedProductsLazyQueryHookResult = ReturnType<typeof useFetchProductPickerSelectedProductsLazyQuery>;
export type FetchProductPickerSelectedProductsSuspenseQueryHookResult = ReturnType<typeof useFetchProductPickerSelectedProductsSuspenseQuery>;
export type FetchProductPickerSelectedProductsQueryResult = Apollo.QueryResult<Types.FetchProductPickerSelectedProductsQuery, Types.FetchProductPickerSelectedProductsQueryVariables>;
export const FetchProductTagsDocument = gql`
    query FetchProductTags($after: String) {
  productTags(first: 250, after: $after) {
    edges {
      node
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useFetchProductTagsQuery__
 *
 * To run a query within a React component, call `useFetchProductTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductTagsQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFetchProductTagsQuery(baseOptions?: Apollo.QueryHookOptions<Types.FetchProductTagsQuery, Types.FetchProductTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchProductTagsQuery, Types.FetchProductTagsQueryVariables>(FetchProductTagsDocument, options);
      }
export function useFetchProductTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchProductTagsQuery, Types.FetchProductTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchProductTagsQuery, Types.FetchProductTagsQueryVariables>(FetchProductTagsDocument, options);
        }
// @ts-ignore
export function useFetchProductTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchProductTagsQuery, Types.FetchProductTagsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductTagsQuery, Types.FetchProductTagsQueryVariables>;
export function useFetchProductTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductTagsQuery, Types.FetchProductTagsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductTagsQuery | undefined, Types.FetchProductTagsQueryVariables>;
export function useFetchProductTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductTagsQuery, Types.FetchProductTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchProductTagsQuery, Types.FetchProductTagsQueryVariables>(FetchProductTagsDocument, options);
        }
export type FetchProductTagsQueryHookResult = ReturnType<typeof useFetchProductTagsQuery>;
export type FetchProductTagsLazyQueryHookResult = ReturnType<typeof useFetchProductTagsLazyQuery>;
export type FetchProductTagsSuspenseQueryHookResult = ReturnType<typeof useFetchProductTagsSuspenseQuery>;
export type FetchProductTagsQueryResult = Apollo.QueryResult<Types.FetchProductTagsQuery, Types.FetchProductTagsQueryVariables>;
export const FetchProductTypesDocument = gql`
    query FetchProductTypes($cursor: String) {
  productTypes(first: 250, after: $cursor) {
    edges {
      node
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useFetchProductTypesQuery__
 *
 * To run a query within a React component, call `useFetchProductTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductTypesQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useFetchProductTypesQuery(baseOptions?: Apollo.QueryHookOptions<Types.FetchProductTypesQuery, Types.FetchProductTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchProductTypesQuery, Types.FetchProductTypesQueryVariables>(FetchProductTypesDocument, options);
      }
export function useFetchProductTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchProductTypesQuery, Types.FetchProductTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchProductTypesQuery, Types.FetchProductTypesQueryVariables>(FetchProductTypesDocument, options);
        }
// @ts-ignore
export function useFetchProductTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchProductTypesQuery, Types.FetchProductTypesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductTypesQuery, Types.FetchProductTypesQueryVariables>;
export function useFetchProductTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductTypesQuery, Types.FetchProductTypesQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductTypesQuery | undefined, Types.FetchProductTypesQueryVariables>;
export function useFetchProductTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductTypesQuery, Types.FetchProductTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchProductTypesQuery, Types.FetchProductTypesQueryVariables>(FetchProductTypesDocument, options);
        }
export type FetchProductTypesQueryHookResult = ReturnType<typeof useFetchProductTypesQuery>;
export type FetchProductTypesLazyQueryHookResult = ReturnType<typeof useFetchProductTypesLazyQuery>;
export type FetchProductTypesSuspenseQueryHookResult = ReturnType<typeof useFetchProductTypesSuspenseQuery>;
export type FetchProductTypesQueryResult = Apollo.QueryResult<Types.FetchProductTypesQuery, Types.FetchProductTypesQueryVariables>;
export const FetchProductVariantDocument = gql`
    query FetchProductVariant($id: ID!) {
  productVariant(id: $id) {
    id
    price
  }
}
    `;

/**
 * __useFetchProductVariantQuery__
 *
 * To run a query within a React component, call `useFetchProductVariantQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductVariantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductVariantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchProductVariantQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchProductVariantQuery, Types.FetchProductVariantQueryVariables> & ({ variables: Types.FetchProductVariantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchProductVariantQuery, Types.FetchProductVariantQueryVariables>(FetchProductVariantDocument, options);
      }
export function useFetchProductVariantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchProductVariantQuery, Types.FetchProductVariantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchProductVariantQuery, Types.FetchProductVariantQueryVariables>(FetchProductVariantDocument, options);
        }
// @ts-ignore
export function useFetchProductVariantSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchProductVariantQuery, Types.FetchProductVariantQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductVariantQuery, Types.FetchProductVariantQueryVariables>;
export function useFetchProductVariantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductVariantQuery, Types.FetchProductVariantQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductVariantQuery | undefined, Types.FetchProductVariantQueryVariables>;
export function useFetchProductVariantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductVariantQuery, Types.FetchProductVariantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchProductVariantQuery, Types.FetchProductVariantQueryVariables>(FetchProductVariantDocument, options);
        }
export type FetchProductVariantQueryHookResult = ReturnType<typeof useFetchProductVariantQuery>;
export type FetchProductVariantLazyQueryHookResult = ReturnType<typeof useFetchProductVariantLazyQuery>;
export type FetchProductVariantSuspenseQueryHookResult = ReturnType<typeof useFetchProductVariantSuspenseQuery>;
export type FetchProductVariantQueryResult = Apollo.QueryResult<Types.FetchProductVariantQuery, Types.FetchProductVariantQueryVariables>;
export const FetchProductVariantsByIdsDocument = gql`
    query FetchProductVariantsByIds($ids: [ID!]!) {
  nodes(ids: $ids) {
    ... on ProductVariant {
      id
      title
      price
      product {
        id
        title
        handle
        requiresSellingPlan
        totalVariants
        featuredMedia {
          ... on MediaImage {
            id
            image {
              url(transform: {maxWidth: 800, maxHeight: 800})
            }
          }
          ... on Video {
            id
            preview {
              image {
                url(transform: {maxWidth: 800, maxHeight: 800})
              }
            }
          }
          ... on ExternalVideo {
            id
            preview {
              image {
                url(transform: {maxWidth: 800, maxHeight: 800})
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchProductVariantsByIdsQuery__
 *
 * To run a query within a React component, call `useFetchProductVariantsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductVariantsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductVariantsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useFetchProductVariantsByIdsQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchProductVariantsByIdsQuery, Types.FetchProductVariantsByIdsQueryVariables> & ({ variables: Types.FetchProductVariantsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchProductVariantsByIdsQuery, Types.FetchProductVariantsByIdsQueryVariables>(FetchProductVariantsByIdsDocument, options);
      }
export function useFetchProductVariantsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchProductVariantsByIdsQuery, Types.FetchProductVariantsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchProductVariantsByIdsQuery, Types.FetchProductVariantsByIdsQueryVariables>(FetchProductVariantsByIdsDocument, options);
        }
// @ts-ignore
export function useFetchProductVariantsByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchProductVariantsByIdsQuery, Types.FetchProductVariantsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductVariantsByIdsQuery, Types.FetchProductVariantsByIdsQueryVariables>;
export function useFetchProductVariantsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductVariantsByIdsQuery, Types.FetchProductVariantsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductVariantsByIdsQuery | undefined, Types.FetchProductVariantsByIdsQueryVariables>;
export function useFetchProductVariantsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductVariantsByIdsQuery, Types.FetchProductVariantsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchProductVariantsByIdsQuery, Types.FetchProductVariantsByIdsQueryVariables>(FetchProductVariantsByIdsDocument, options);
        }
export type FetchProductVariantsByIdsQueryHookResult = ReturnType<typeof useFetchProductVariantsByIdsQuery>;
export type FetchProductVariantsByIdsLazyQueryHookResult = ReturnType<typeof useFetchProductVariantsByIdsLazyQuery>;
export type FetchProductVariantsByIdsSuspenseQueryHookResult = ReturnType<typeof useFetchProductVariantsByIdsSuspenseQuery>;
export type FetchProductVariantsByIdsQueryResult = Apollo.QueryResult<Types.FetchProductVariantsByIdsQuery, Types.FetchProductVariantsByIdsQueryVariables>;
export const FetchProductVendorsDocument = gql`
    query FetchProductVendors($cursor: String) {
  productVendors(first: 250, after: $cursor) {
    edges {
      node
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useFetchProductVendorsQuery__
 *
 * To run a query within a React component, call `useFetchProductVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductVendorsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useFetchProductVendorsQuery(baseOptions?: Apollo.QueryHookOptions<Types.FetchProductVendorsQuery, Types.FetchProductVendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchProductVendorsQuery, Types.FetchProductVendorsQueryVariables>(FetchProductVendorsDocument, options);
      }
export function useFetchProductVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchProductVendorsQuery, Types.FetchProductVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchProductVendorsQuery, Types.FetchProductVendorsQueryVariables>(FetchProductVendorsDocument, options);
        }
// @ts-ignore
export function useFetchProductVendorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchProductVendorsQuery, Types.FetchProductVendorsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductVendorsQuery, Types.FetchProductVendorsQueryVariables>;
export function useFetchProductVendorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductVendorsQuery, Types.FetchProductVendorsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductVendorsQuery | undefined, Types.FetchProductVendorsQueryVariables>;
export function useFetchProductVendorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductVendorsQuery, Types.FetchProductVendorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchProductVendorsQuery, Types.FetchProductVendorsQueryVariables>(FetchProductVendorsDocument, options);
        }
export type FetchProductVendorsQueryHookResult = ReturnType<typeof useFetchProductVendorsQuery>;
export type FetchProductVendorsLazyQueryHookResult = ReturnType<typeof useFetchProductVendorsLazyQuery>;
export type FetchProductVendorsSuspenseQueryHookResult = ReturnType<typeof useFetchProductVendorsSuspenseQuery>;
export type FetchProductVendorsQueryResult = Apollo.QueryResult<Types.FetchProductVendorsQuery, Types.FetchProductVendorsQueryVariables>;
export const FetchProductsDocument = gql`
    query FetchProducts($endCursor: String) {
  products(
    first: 250
    query: "status:Active OR status:Unlisted"
    after: $endCursor
  ) {
    edges {
      node {
        id
        handle
        templateSuffix
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useFetchProductsQuery__
 *
 * To run a query within a React component, call `useFetchProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductsQuery({
 *   variables: {
 *      endCursor: // value for 'endCursor'
 *   },
 * });
 */
export function useFetchProductsQuery(baseOptions?: Apollo.QueryHookOptions<Types.FetchProductsQuery, Types.FetchProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchProductsQuery, Types.FetchProductsQueryVariables>(FetchProductsDocument, options);
      }
export function useFetchProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchProductsQuery, Types.FetchProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchProductsQuery, Types.FetchProductsQueryVariables>(FetchProductsDocument, options);
        }
// @ts-ignore
export function useFetchProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchProductsQuery, Types.FetchProductsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductsQuery, Types.FetchProductsQueryVariables>;
export function useFetchProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductsQuery, Types.FetchProductsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductsQuery | undefined, Types.FetchProductsQueryVariables>;
export function useFetchProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductsQuery, Types.FetchProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchProductsQuery, Types.FetchProductsQueryVariables>(FetchProductsDocument, options);
        }
export type FetchProductsQueryHookResult = ReturnType<typeof useFetchProductsQuery>;
export type FetchProductsLazyQueryHookResult = ReturnType<typeof useFetchProductsLazyQuery>;
export type FetchProductsSuspenseQueryHookResult = ReturnType<typeof useFetchProductsSuspenseQuery>;
export type FetchProductsQueryResult = Apollo.QueryResult<Types.FetchProductsQuery, Types.FetchProductsQueryVariables>;
export const FetchProductsByIdDocument = gql`
    query FetchProductsById($ids: [ID!]!) {
  nodes(ids: $ids) {
    ... on Product {
      id
      featuredImage {
        url(transform: {maxWidth: 50, maxHeight: 50})
      }
      variants(first: 250) {
        edges {
          cursor
          node {
            id
            price
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchProductsByIdQuery__
 *
 * To run a query within a React component, call `useFetchProductsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductsByIdQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useFetchProductsByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchProductsByIdQuery, Types.FetchProductsByIdQueryVariables> & ({ variables: Types.FetchProductsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchProductsByIdQuery, Types.FetchProductsByIdQueryVariables>(FetchProductsByIdDocument, options);
      }
export function useFetchProductsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchProductsByIdQuery, Types.FetchProductsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchProductsByIdQuery, Types.FetchProductsByIdQueryVariables>(FetchProductsByIdDocument, options);
        }
// @ts-ignore
export function useFetchProductsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchProductsByIdQuery, Types.FetchProductsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductsByIdQuery, Types.FetchProductsByIdQueryVariables>;
export function useFetchProductsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductsByIdQuery, Types.FetchProductsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductsByIdQuery | undefined, Types.FetchProductsByIdQueryVariables>;
export function useFetchProductsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductsByIdQuery, Types.FetchProductsByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchProductsByIdQuery, Types.FetchProductsByIdQueryVariables>(FetchProductsByIdDocument, options);
        }
export type FetchProductsByIdQueryHookResult = ReturnType<typeof useFetchProductsByIdQuery>;
export type FetchProductsByIdLazyQueryHookResult = ReturnType<typeof useFetchProductsByIdLazyQuery>;
export type FetchProductsByIdSuspenseQueryHookResult = ReturnType<typeof useFetchProductsByIdSuspenseQuery>;
export type FetchProductsByIdQueryResult = Apollo.QueryResult<Types.FetchProductsByIdQuery, Types.FetchProductsByIdQueryVariables>;
export const FetchProductsByIdsDocument = gql`
    query FetchProductsByIds($ids: [ID!]!) {
  nodes(ids: $ids) {
    ... on Product {
      id
      title
      handle
      totalVariants
      featuredMedia {
        ... on MediaImage {
          id
          image {
            url(transform: {maxWidth: 800, maxHeight: 800})
          }
        }
      }
      variants(first: 250) {
        nodes {
          id
          title
        }
      }
    }
  }
}
    `;

/**
 * __useFetchProductsByIdsQuery__
 *
 * To run a query within a React component, call `useFetchProductsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useFetchProductsByIdsQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchProductsByIdsQuery, Types.FetchProductsByIdsQueryVariables> & ({ variables: Types.FetchProductsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchProductsByIdsQuery, Types.FetchProductsByIdsQueryVariables>(FetchProductsByIdsDocument, options);
      }
export function useFetchProductsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchProductsByIdsQuery, Types.FetchProductsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchProductsByIdsQuery, Types.FetchProductsByIdsQueryVariables>(FetchProductsByIdsDocument, options);
        }
// @ts-ignore
export function useFetchProductsByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchProductsByIdsQuery, Types.FetchProductsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductsByIdsQuery, Types.FetchProductsByIdsQueryVariables>;
export function useFetchProductsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductsByIdsQuery, Types.FetchProductsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductsByIdsQuery | undefined, Types.FetchProductsByIdsQueryVariables>;
export function useFetchProductsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductsByIdsQuery, Types.FetchProductsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchProductsByIdsQuery, Types.FetchProductsByIdsQueryVariables>(FetchProductsByIdsDocument, options);
        }
export type FetchProductsByIdsQueryHookResult = ReturnType<typeof useFetchProductsByIdsQuery>;
export type FetchProductsByIdsLazyQueryHookResult = ReturnType<typeof useFetchProductsByIdsLazyQuery>;
export type FetchProductsByIdsSuspenseQueryHookResult = ReturnType<typeof useFetchProductsByIdsSuspenseQuery>;
export type FetchProductsByIdsQueryResult = Apollo.QueryResult<Types.FetchProductsByIdsQuery, Types.FetchProductsByIdsQueryVariables>;
export const FetchProductsVariantsDocument = gql`
    query FetchProductsVariants($ids: [ID!]!, $after: String, $first: Int) {
  nodes(ids: $ids) {
    ... on Product {
      id
      title
      handle
      status
      featuredImage {
        url(transform: {maxWidth: 50, maxHeight: 50})
      }
      totalVariants
      priceRange {
        maxVariantPrice {
          amount
        }
        minVariantPrice {
          amount
        }
      }
      variants(first: $first, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          cursor
          node {
            id
            title
            price
            compareAtPrice
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchProductsVariantsQuery__
 *
 * To run a query within a React component, call `useFetchProductsVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductsVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductsVariantsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFetchProductsVariantsQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchProductsVariantsQuery, Types.FetchProductsVariantsQueryVariables> & ({ variables: Types.FetchProductsVariantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchProductsVariantsQuery, Types.FetchProductsVariantsQueryVariables>(FetchProductsVariantsDocument, options);
      }
export function useFetchProductsVariantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchProductsVariantsQuery, Types.FetchProductsVariantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchProductsVariantsQuery, Types.FetchProductsVariantsQueryVariables>(FetchProductsVariantsDocument, options);
        }
// @ts-ignore
export function useFetchProductsVariantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchProductsVariantsQuery, Types.FetchProductsVariantsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductsVariantsQuery, Types.FetchProductsVariantsQueryVariables>;
export function useFetchProductsVariantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductsVariantsQuery, Types.FetchProductsVariantsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchProductsVariantsQuery | undefined, Types.FetchProductsVariantsQueryVariables>;
export function useFetchProductsVariantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchProductsVariantsQuery, Types.FetchProductsVariantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchProductsVariantsQuery, Types.FetchProductsVariantsQueryVariables>(FetchProductsVariantsDocument, options);
        }
export type FetchProductsVariantsQueryHookResult = ReturnType<typeof useFetchProductsVariantsQuery>;
export type FetchProductsVariantsLazyQueryHookResult = ReturnType<typeof useFetchProductsVariantsLazyQuery>;
export type FetchProductsVariantsSuspenseQueryHookResult = ReturnType<typeof useFetchProductsVariantsSuspenseQuery>;
export type FetchProductsVariantsQueryResult = Apollo.QueryResult<Types.FetchProductsVariantsQuery, Types.FetchProductsVariantsQueryVariables>;
export const FetchPublishedCheckoutAndAccountsConfigurationDocument = gql`
    query FetchPublishedCheckoutAndAccountsConfiguration {
  checkoutAndAccountsConfigurations(query: "is_published:true", first: 1) {
    edges {
      node {
        id
        name
        isPublished
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useFetchPublishedCheckoutAndAccountsConfigurationQuery__
 *
 * To run a query within a React component, call `useFetchPublishedCheckoutAndAccountsConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPublishedCheckoutAndAccountsConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPublishedCheckoutAndAccountsConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchPublishedCheckoutAndAccountsConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<Types.FetchPublishedCheckoutAndAccountsConfigurationQuery, Types.FetchPublishedCheckoutAndAccountsConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchPublishedCheckoutAndAccountsConfigurationQuery, Types.FetchPublishedCheckoutAndAccountsConfigurationQueryVariables>(FetchPublishedCheckoutAndAccountsConfigurationDocument, options);
      }
export function useFetchPublishedCheckoutAndAccountsConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchPublishedCheckoutAndAccountsConfigurationQuery, Types.FetchPublishedCheckoutAndAccountsConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchPublishedCheckoutAndAccountsConfigurationQuery, Types.FetchPublishedCheckoutAndAccountsConfigurationQueryVariables>(FetchPublishedCheckoutAndAccountsConfigurationDocument, options);
        }
// @ts-ignore
export function useFetchPublishedCheckoutAndAccountsConfigurationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchPublishedCheckoutAndAccountsConfigurationQuery, Types.FetchPublishedCheckoutAndAccountsConfigurationQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchPublishedCheckoutAndAccountsConfigurationQuery, Types.FetchPublishedCheckoutAndAccountsConfigurationQueryVariables>;
export function useFetchPublishedCheckoutAndAccountsConfigurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchPublishedCheckoutAndAccountsConfigurationQuery, Types.FetchPublishedCheckoutAndAccountsConfigurationQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchPublishedCheckoutAndAccountsConfigurationQuery | undefined, Types.FetchPublishedCheckoutAndAccountsConfigurationQueryVariables>;
export function useFetchPublishedCheckoutAndAccountsConfigurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchPublishedCheckoutAndAccountsConfigurationQuery, Types.FetchPublishedCheckoutAndAccountsConfigurationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchPublishedCheckoutAndAccountsConfigurationQuery, Types.FetchPublishedCheckoutAndAccountsConfigurationQueryVariables>(FetchPublishedCheckoutAndAccountsConfigurationDocument, options);
        }
export type FetchPublishedCheckoutAndAccountsConfigurationQueryHookResult = ReturnType<typeof useFetchPublishedCheckoutAndAccountsConfigurationQuery>;
export type FetchPublishedCheckoutAndAccountsConfigurationLazyQueryHookResult = ReturnType<typeof useFetchPublishedCheckoutAndAccountsConfigurationLazyQuery>;
export type FetchPublishedCheckoutAndAccountsConfigurationSuspenseQueryHookResult = ReturnType<typeof useFetchPublishedCheckoutAndAccountsConfigurationSuspenseQuery>;
export type FetchPublishedCheckoutAndAccountsConfigurationQueryResult = Apollo.QueryResult<Types.FetchPublishedCheckoutAndAccountsConfigurationQuery, Types.FetchPublishedCheckoutAndAccountsConfigurationQueryVariables>;
export const FetchPublishedCheckoutProfileDocument = gql`
    query FetchPublishedCheckoutProfile {
  checkoutProfiles(query: "is_published:true", first: 1) {
    edges {
      node {
        id
        name
        isPublished
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useFetchPublishedCheckoutProfileQuery__
 *
 * To run a query within a React component, call `useFetchPublishedCheckoutProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPublishedCheckoutProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPublishedCheckoutProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchPublishedCheckoutProfileQuery(baseOptions?: Apollo.QueryHookOptions<Types.FetchPublishedCheckoutProfileQuery, Types.FetchPublishedCheckoutProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchPublishedCheckoutProfileQuery, Types.FetchPublishedCheckoutProfileQueryVariables>(FetchPublishedCheckoutProfileDocument, options);
      }
export function useFetchPublishedCheckoutProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchPublishedCheckoutProfileQuery, Types.FetchPublishedCheckoutProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchPublishedCheckoutProfileQuery, Types.FetchPublishedCheckoutProfileQueryVariables>(FetchPublishedCheckoutProfileDocument, options);
        }
// @ts-ignore
export function useFetchPublishedCheckoutProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchPublishedCheckoutProfileQuery, Types.FetchPublishedCheckoutProfileQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchPublishedCheckoutProfileQuery, Types.FetchPublishedCheckoutProfileQueryVariables>;
export function useFetchPublishedCheckoutProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchPublishedCheckoutProfileQuery, Types.FetchPublishedCheckoutProfileQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchPublishedCheckoutProfileQuery | undefined, Types.FetchPublishedCheckoutProfileQueryVariables>;
export function useFetchPublishedCheckoutProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchPublishedCheckoutProfileQuery, Types.FetchPublishedCheckoutProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchPublishedCheckoutProfileQuery, Types.FetchPublishedCheckoutProfileQueryVariables>(FetchPublishedCheckoutProfileDocument, options);
        }
export type FetchPublishedCheckoutProfileQueryHookResult = ReturnType<typeof useFetchPublishedCheckoutProfileQuery>;
export type FetchPublishedCheckoutProfileLazyQueryHookResult = ReturnType<typeof useFetchPublishedCheckoutProfileLazyQuery>;
export type FetchPublishedCheckoutProfileSuspenseQueryHookResult = ReturnType<typeof useFetchPublishedCheckoutProfileSuspenseQuery>;
export type FetchPublishedCheckoutProfileQueryResult = Apollo.QueryResult<Types.FetchPublishedCheckoutProfileQuery, Types.FetchPublishedCheckoutProfileQueryVariables>;
export const FetchShippingProductsDocument = gql`
    query FetchShippingProducts($deliveryProfileId: ID!, $numProducts: Int!, $productsCursor: String) {
  deliveryProfile(id: $deliveryProfileId) {
    id
    name
    profileItems(first: $numProducts, after: $productsCursor) {
      edges {
        node {
          id
          product {
            id
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __useFetchShippingProductsQuery__
 *
 * To run a query within a React component, call `useFetchShippingProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchShippingProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchShippingProductsQuery({
 *   variables: {
 *      deliveryProfileId: // value for 'deliveryProfileId'
 *      numProducts: // value for 'numProducts'
 *      productsCursor: // value for 'productsCursor'
 *   },
 * });
 */
export function useFetchShippingProductsQuery(baseOptions: Apollo.QueryHookOptions<Types.FetchShippingProductsQuery, Types.FetchShippingProductsQueryVariables> & ({ variables: Types.FetchShippingProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FetchShippingProductsQuery, Types.FetchShippingProductsQueryVariables>(FetchShippingProductsDocument, options);
      }
export function useFetchShippingProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FetchShippingProductsQuery, Types.FetchShippingProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FetchShippingProductsQuery, Types.FetchShippingProductsQueryVariables>(FetchShippingProductsDocument, options);
        }
// @ts-ignore
export function useFetchShippingProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FetchShippingProductsQuery, Types.FetchShippingProductsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchShippingProductsQuery, Types.FetchShippingProductsQueryVariables>;
export function useFetchShippingProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchShippingProductsQuery, Types.FetchShippingProductsQueryVariables>): Apollo.UseSuspenseQueryResult<Types.FetchShippingProductsQuery | undefined, Types.FetchShippingProductsQueryVariables>;
export function useFetchShippingProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.FetchShippingProductsQuery, Types.FetchShippingProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FetchShippingProductsQuery, Types.FetchShippingProductsQueryVariables>(FetchShippingProductsDocument, options);
        }
export type FetchShippingProductsQueryHookResult = ReturnType<typeof useFetchShippingProductsQuery>;
export type FetchShippingProductsLazyQueryHookResult = ReturnType<typeof useFetchShippingProductsLazyQuery>;
export type FetchShippingProductsSuspenseQueryHookResult = ReturnType<typeof useFetchShippingProductsSuspenseQuery>;
export type FetchShippingProductsQueryResult = Apollo.QueryResult<Types.FetchShippingProductsQuery, Types.FetchShippingProductsQueryVariables>;